import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";
import $ from "jquery";
import CONFIG from "@bd-core/config";

/**
 * Intro Slides Component
 */
export const IntroSlides = () => {
    const $introSlides = $("#intro-slides");
    if (!$introSlides.length) return;

    const $slides = $introSlides.find(".intro-slides__slide");
    const $nextBtn = $("#intro-slides-next");
    const total = $slides.length;
    let current = 0;

    const showSlide = (index) => {
        if(CONFIG.isIntroCompleted && index > 0) {
            window.location.href = '/';
            return;
        }

        $nextBtn.show();
        current = Math.max(0, Math.min(index, total - 1));
        $slides.removeClass("is-active-slide").eq(current).addClass("is-active-slide");
        $nextBtn.text($slides.eq(current).data("button-text"));
    };

    const next = () => (current < total - 1 ? showSlide(current + 1) : complete());

    const complete = async () => {
        $introSlides.addClass("intro-slides--hidden");
        
        // Get return state if exists
        const urlParams = new URLSearchParams(window.location.search);
        const returnState = urlParams.get('return_state');

        const [response] = await bdjs.goAsync(
            bdapi.post("game/complete-intro", {
                return_state: returnState || ''
            }),
        );
        
        if (response?.data?.success) {
            setTimeout(() => {
                $introSlides.hide();
                $("#intro-page").addClass("intro-page--hidden");
                $(document).trigger("umc:intro-complete");
                
                // Redirect to home or preserved state
                if (response?.data?.data?.redirect_url) {
                    window.location.href = response?.data?.data?.redirect_url;
                } else {
                    window.location.href = '/';
                }
            }, 500);
        } else {
            console.error('Failed to complete intro:', response?.data?.message);
            // Still redirect on error to not block user
            window.location.href = '/';
        }
    };

    const start = () => {
        const startBtn = document.getElementById('loading-intro-start');
        const loadingIntro = document.getElementById('loading-intro');
        const introSlides = document.getElementById('intro-slides');
        const nextBtn = document.getElementById('intro-slides-next');

        nextBtn.style.display = 'none';

        if (startBtn && loadingIntro) {
            startBtn.addEventListener('click', function() {
                // Hide loading intro
                loadingIntro.classList.add('loading-intro--hidden');
                next();
                
                // Show intro slides
                if (introSlides) {
                    introSlides.classList.add('intro-slides--active');
                    introSlides.setAttribute('aria-hidden', 'false');
                }

                setTimeout(function() {
                    loadingIntro.style.display = 'none';
                }, 500);
            });
        }
    };

    $nextBtn.on("click", next);
    showSlide(0);
    start();

    // Expose API for external access (with TypeScript support)
    /** @type {any} */ (window).introSlides = { showSlide, next, complete, getCurrent: () => current };
};

export default IntroSlides;
